export default "__VITE_ASSET__BhE$ibLf__"